import { tryGetHostApi } from "./externalApi";
export async function requestHide() {
    const windowApi = await tryGetHostApi("Window", 1, 1);
    if (windowApi) {
        await windowApi.requestHide();
    }
}
export async function getIsWindowVisible() {
    const windowApi = await tryGetHostApi("Window", 1, 1);
    if (windowApi) {
        const isWindowVisible = await windowApi.isVisible;
        return isWindowVisible;
    }
    else {
        return Promise.reject("No windowApi found");
    }
}
export async function getLastShowReason() {
    const windowApi = await tryGetHostApi("Window", 1, 1);
    if (windowApi) {
        return await windowApi.lastShowReason;
    }
    return "unknown";
}
export async function addVisibilityEventListeners(windowVisibleCallback, windowHiddenCallback) {
    // For dev experience milestone
    const windowApi = await tryGetHostApi("Window", 1, 1);
    if (windowApi) {
        if (windowVisibleCallback) {
            await windowApi.addEventListener("shown", windowVisibleCallback);
        }
        if (windowHiddenCallback) {
            await windowApi.addEventListener("hidden", windowHiddenCallback);
        }
    }
}
export async function removeVisibilityEventListeners(windowVisibleCallback, windowHiddenCallback) {
    // For dev experience milestone
    const windowApi = await tryGetHostApi("Window", 1, 1);
    if (windowApi) {
        if (windowVisibleCallback) {
            await windowApi.removeEventListener("shown", windowVisibleCallback);
        }
        if (windowHiddenCallback) {
            await windowApi.removeEventListener("hidden", windowHiddenCallback);
        }
    }
}
export async function addViewStateUpdatedEventListener(viewStateUpdatedCallback) {
    const windowApi = await tryGetHostApi("Window", 2, 2);
    if (windowApi) {
        await windowApi.addEventListener("viewStateUpdated", viewStateUpdatedCallback);
    }
}
export async function removeViewStateUpdatedEventListener(viewStateUpdatedCallback) {
    const windowApi = await tryGetHostApi("Window", 2, 2);
    if (windowApi) {
        await windowApi.removeEventListener("viewStateUpdated", viewStateUpdatedCallback);
    }
}
export async function getViewState() {
    const windowApi = await tryGetHostApi("Window", 2, 2);
    if (windowApi) {
        return await windowApi.viewState;
    }
    return 0;
}
export async function requestChangeView(isExtended) {
    const windowApi = await tryGetHostApi("Window", 2, 2);
    if (windowApi) {
        await windowApi.requestChangeView(isExtended);
    }
}
export async function isPinWidgetsFlyout() {
    const windowApi = await tryGetHostApi("Window", 4, 4);
    if (windowApi) {
        return await windowApi.isPinWidgetsFlyout;
    }
    return false;
}
export async function setPinWidgetsFlyout(isPinned) {
    const windowApi = await tryGetHostApi("Window", 4, 4);
    if (windowApi) {
        await windowApi.setPinWidgetsFlyout(isPinned);
    }
}
export async function addViewWidthUpdatedEventListener(viewWidthUpdatedCallback) {
    const windowApi = await tryGetHostApi("Window", 2, 2);
    if (windowApi) {
        await windowApi.addEventListener("viewWidthUpdated", viewWidthUpdatedCallback);
    }
}
export async function removeViewWidthUpdatedEventListener(viewWidthUpdatedCallback) {
    const windowApi = await tryGetHostApi("Window", 2, 2);
    if (windowApi) {
        await windowApi.removeEventListener("viewWidthUpdated", viewWidthUpdatedCallback);
    }
}
export async function getViewWidth() {
    const windowApi = await tryGetHostApi("Window", 2, 2);
    if (windowApi) {
        const viewWidth = await windowApi.viewWidth;
        return viewWidth;
    }
    else {
        return Promise.reject("No windowApi found");
    }
}
